import { Icon } from '@iconify/react';
import { PATH_DASHBOARD } from '../../../routes/paths';


const navConfig = [
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      { title: 'Subscription', path: PATH_DASHBOARD.dorm.dorm, icon: <Icon icon="material-symbols-light:subscriptions-rounded" /> },
      { title: 'Promo Codes ', path: PATH_DASHBOARD.promo.promo, icon: <Icon icon="hugeicons:promotion" /> },
      { title: 'Employee', path: PATH_DASHBOARD.element.element, icon: <Icon icon="iconoir:user" /> },
      { title: 'Clinic', path: PATH_DASHBOARD.magictype.magictype, icon: <Icon icon="bx:clinic" /> },
      { title: 'Provider', path: PATH_DASHBOARD.spell.spell, icon: <Icon icon="healthicons:doctor" /> },
      { title: 'Bookings', path: PATH_DASHBOARD.appointment.appointment, icon: <Icon icon="teenyicons:appointments-outline" /> },
      { title: 'Manage Registration ', path: PATH_DASHBOARD.character.character, icon: <Icon icon="material-symbols:app-registration" /> },
      { title: 'Student', path: PATH_DASHBOARD.student.student, icon: <Icon icon="ph:student" /> },
      { title: 'Notifications', path: PATH_DASHBOARD.notification.notification, icon: <Icon icon="ph:bell" /> },
      {
        title: 'Checker Payment', path: PATH_DASHBOARD.checkerpayment.checkerpayment, icon: <Icon icon="ph:credit-card" />
      }
    ],
  },
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      { title: 'Clinic', path: PATH_DASHBOARD.magictype.magictype, icon: <Icon icon="bx:clinic" /> },
      { title: 'Provider', path: PATH_DASHBOARD.spell.spell, icon: <Icon icon="healthicons:doctor" /> },
      { title: 'Bookings', path: PATH_DASHBOARD.appointment.appointment, icon: <Icon icon="teenyicons:appointments-outline" /> },
      { title: 'Student', path: PATH_DASHBOARD.student.student, icon: <Icon icon="ph:student" /> },

    ],
  },
  {
    items: [
      { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
      { title: 'Provider', path: PATH_DASHBOARD.spell.spell, icon: <Icon icon="healthicons:doctor" /> },
      { title: 'Slot', path: PATH_DASHBOARD.slot.all_slot, icon: <Icon icon="entypo:time-slot" /> },
      { title: 'Bookings', path: PATH_DASHBOARD.appointment.appointment, icon: <Icon icon="teenyicons:appointments-outline" /> },
      { title: 'Today’s Shadows', path: PATH_DASHBOARD.appointment.todayShadow, icon: <Icon icon="teenyicons:appointments-outline" /> },
      // { title: 'Student Attendance', path: PATH_DASHBOARD.tag.tag, icon: <Icon icon="ph:student-fill" /> },
      // { title: 'Review', path: PATH_DASHBOARD.review.review, icon: <Icon icon="material-symbols:rate-review-outline"/> },
      { title: 'Terms & Conditions', path: PATH_DASHBOARD.rarity.rarity, icon: <Icon icon="fe:warning" /> },
      { title: 'Dress Code', path: '/dashboard/dresscode', icon: <Icon icon="material-symbols:dresser" /> },
      { title: 'Forms', path: '/dashboard/Form', icon: <Icon icon="material-symbols:app-registration" /> },
      { title: 'Check-in Info', path: '/dashboard/checkinInfo', icon: <Icon icon="material-symbols:library-add-check-outline" /> },
    ],
  },

  // {
  //   subheader: 'management',
  //   items: [
  //     // USER
  //     {
  //       title: 'user',
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: 'profile', path: PATH_DASHBOARD.user.profile },
  //         { title: 'cards', path: PATH_DASHBOARD.user.cards },
  //         { title: 'list', path: PATH_DASHBOARD.user.list },
  //         { title: 'create', path: PATH_DASHBOARD.user.new },
  //         { title: 'edit', path: PATH_DASHBOARD.user.demoEdit },
  //         { title: 'account', path: PATH_DASHBOARD.user.account },
  //       ],
  //     },

  //     // E-COMMERCE
  // {
  //   title: 'e-commerce',
  //   path: PATH_DASHBOARD.eCommerce.root,
  //   icon: ICONS.cart,
  //   children: [
  //     { title: 'shop', path: PATH_DASHBOARD.eCommerce.shop },
  //     { title: 'product', path: PATH_DASHBOARD.eCommerce.demoView },
  //     { title: 'list', path: PATH_DASHBOARD.eCommerce.list },
  //     { title: 'create', path: PATH_DASHBOARD.eCommerce.new },
  //     { title: 'edit', path: PATH_DASHBOARD.eCommerce.demoEdit },
  //     { title: 'checkout', path: PATH_DASHBOARD.eCommerce.checkout },
  //   ],
  // },

  //     // INVOICE
  //     {
  //       title: 'invoice',
  //       path: PATH_DASHBOARD.invoice.root,
  //       icon: ICONS.invoice,
  //       children: [
  //         { title: 'list', path: PATH_DASHBOARD.invoice.list },
  //         { title: 'details', path: PATH_DASHBOARD.invoice.demoView },
  //         { title: 'create', path: PATH_DASHBOARD.invoice.new },
  //         { title: 'edit', path: PATH_DASHBOARD.invoice.demoEdit },
  //       ],
  //     },

  // BLOG
  // {
  //   title: 'blog',
  //   path: PATH_DASHBOARD.blog.root,
  //   icon: ICONS.blog,
  //   children: [
  //     { title: 'posts', path: PATH_DASHBOARD.blog.posts },
  //     { title: 'post', path: PATH_DASHBOARD.blog.demoView },
  //     { title: 'create', path: PATH_DASHBOARD.blog.new },
  //   ],
  // },
  //   ],
  // },

  // APP
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'app',
  //   items: [
  //     {
  //       title: 'mail',
  //       path: PATH_DASHBOARD.mail.root,
  //       icon: ICONS.mail,
  //       info: (
  //         <Label variant="outlined" color="error">
  //           +32
  //         </Label>
  //       ),
  //     },
  //     { title: 'chat', path: PATH_DASHBOARD.chat.root, icon: ICONS.chat },
  //     { title: 'calendar', path: PATH_DASHBOARD.calendar, icon: ICONS.calendar },
  //     { title: 'kanban', path: PATH_DASHBOARD.kanban, icon: ICONS.kanban },
  //   ],
  // },
];

export default navConfig;
